import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArtDirection = makeShortcode("ArtDirection");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Button`}</h1>
    <PageDescription mdxType="PageDescription">
      <p>{`Mit einem Button wird eine Aktion initialisiert. Über die Button-Beschriftung wird angegeben, welche Aktion ausgeführt wird.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Überblick</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Formartierung</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Code</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Inhalt</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Referenzen</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Feedback</AnchorLink>
    </AnchorLinks>
    <h2>{`Überblick`}</h2>
    <p>{`Button sind anklickbare Elemente, mit denen Aktionen ausgelöst werden. Über den hier zur Verfügung gestellten Button ist es möglich auf verschiedene Weise mit Seiten zu interagieren.
Über die Button-Beschriftung wird dabei angegeben, welche Aktion ausgeführt wird.`}</p>
    <h4>{`Wann zu verwenden`}</h4>
    <p>{`Der Button ist für Verlinkung zu anderen Seiten zu benutzten.`}</p>
    <h3>{`Varianten`}</h3>
    <p>{`Für den Button stehen zwei Varianten zur Verfügung`}</p>
    <Row mdxType="Row">
      <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "39.23611111111111%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAACxLAAAsSwGlPZapAAAArElEQVQoz5VSOw7CMAzNxTkDh+AAbKzMnIAVgRCVStlQCa39SOrUIm6ChCUr/ry82LEdgjAzWAyxVQHNJycebHAzJorLCBEBI5gGOVEinKMo+u4rA5PLSNSefJIHg9q8qZDQX7d4HNcYun0GlguJ9N2BXw3Yt6EbX2l58kc8TxucDyv4ZpeAtCT0d1B/CaS3MiH0//5vuT4UtkOhjLg2FBtzugtYrkOxwh+YKB+gy3ioU3f5cAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Button variants",
            "title": "Button variants",
            "src": "/static/5c9eb6156ef01b18ecf3355e94f91257/3cbba/button-variants.png",
            "srcSet": ["/static/5c9eb6156ef01b18ecf3355e94f91257/7fc1e/button-variants.png 288w", "/static/5c9eb6156ef01b18ecf3355e94f91257/a5df1/button-variants.png 576w", "/static/5c9eb6156ef01b18ecf3355e94f91257/3cbba/button-variants.png 1152w", "/static/5c9eb6156ef01b18ecf3355e94f91257/0b124/button-variants.png 1728w", "/static/5c9eb6156ef01b18ecf3355e94f91257/4ea69/button-variants.png 2304w", "/static/5c9eb6156ef01b18ecf3355e94f91257/bc255/button-variants.png 3060w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Variant`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Purpose`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Primary`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Der primäre Button besteht aus einem ausgefüllten Container und einem Label für aktive und relevante Aktionen`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Secondary`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Der sekundäre Button besteht aus einem Rahmen und einem Label für zusätzliche nicht aktive Aktionen`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Größe`}</h3>
    <Row mdxType="Row">
      <Column colLg={12} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "39.23611111111111%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAACE4AAAhOAFFljFgAAAA00lEQVQoz6WSvwrCQAzGfWu7irMv4eKqL+AgSpUOLiIOgiJS0KFVW1HxLp/3p413h508CPc1P5Iml7QQHCLiu9YhN+ZqewxufRNIZUKLILHyyzczTsRMaCOjdUI32Gjr+Fmhy+AzroIrfGUJ7scRIIrq78L4ZblBsevjmQ4VKy2TFcsnOC07yFZdouuiblka+DhPkW0HKujmBYl8jn0cIV/39Aczc2djHOI20iQiusz+b5ncWYUt1w/sPjxPVVekOwmGAmcoFbMVNq+Ntxr+ujSszQdvYHNHgw30VQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Button variants",
            "title": "Button variants",
            "src": "/static/12bcdfde871ee9747d24c2d0d60fc722/3cbba/button-sizes.png",
            "srcSet": ["/static/12bcdfde871ee9747d24c2d0d60fc722/7fc1e/button-sizes.png 288w", "/static/12bcdfde871ee9747d24c2d0d60fc722/a5df1/button-sizes.png 576w", "/static/12bcdfde871ee9747d24c2d0d60fc722/3cbba/button-sizes.png 1152w", "/static/12bcdfde871ee9747d24c2d0d60fc722/0b124/button-sizes.png 1728w", "/static/12bcdfde871ee9747d24c2d0d60fc722/78cf1/button-sizes.png 2295w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Variant`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Purpose`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Small`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`For less prominent, and sometimes independent, actions. Tertiary buttons can be used in isolation or paired with a primary button when there are multiple calls to action. Tertiary buttons can also be used for sub-tasks on a page where a primary button for the main and final action is present.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Medium`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`For the least pronounced actions; often used in conjunction with a primary button. In a situation such as a progress flow, a ghost button may be paired with a primary and secondary button set, where the primary button is for forward action, the secondary button is for “Back”, and the ghost button is for “Cancel”.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Large`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`For the least pronounced actions; often used in conjunction with a primary button. In a situation such as a progress flow, a ghost button may be paired with a primary and secondary button set, where the primary button is for forward action, the secondary button is for “Back”, and the ghost button is for “Cancel”.`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Formartierung`}</h2>
    <h3>{`Anatomy`}</h3>
    <p>{`Der Button besteht aus einem Container und einem Label. Das Label ist dabei ein wichtiges Element, um die Aktion zu kommunizieren.`}</p>
    <ArtDirection mdxType="ArtDirection">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "579px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "88.19444444444444%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAABCcAAAQnAEmzTo0AAABEklEQVQ4y2P4T2XAMGogdQz89+8fGIPA379/wRgi9gcHhqiF0ThdiE3BPzSMTy1WF96+ffv/g4cP/79+/fL/hzvz//9/Ov3//+ezwPjf0xn/fz2Z9//f70/4XYhsoJ6OGhCr/t+8edP/Vwdd/l9apvh/UYPU/9UdMv/PLVH6/+es/f+/359CDfxL2MANG9b/37Fjx//Hjx/+f3ep/v+bs3n/V89M+L9udtL/G3uz//+5W/v/78+3+A3EFS5/odyVK1f+nzBhAmqYEhuGf/78AWMQ/8/vX2CxsGCv/5qq0v+/ff+B4jKCsYysCNmS16/f/H/06DGGIUQZiM1gfGIk5RT0xI7uclwG/qEmpklePklNDABXrnNY1S+uTAAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "ArtefactCard anatomy",
          "title": "ArtefactCard anatomy",
          "src": "/static/32b686a29831bd9b689650f1197ceed8/9b322/button-anatomy.png",
          "srcSet": ["/static/32b686a29831bd9b689650f1197ceed8/7fc1e/button-anatomy.png 288w", "/static/32b686a29831bd9b689650f1197ceed8/a5df1/button-anatomy.png 576w", "/static/32b686a29831bd9b689650f1197ceed8/9b322/button-anatomy.png 579w"],
          "sizes": "(max-width: 579px) 100vw, 579px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </ArtDirection>
    <ol>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Container`}</strong></p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Label`}</strong></p>
      </li>
    </ol>
    <h2>{`Code`}</h2>
    <h3>{`Dokumentation`}</h3>
    <p>{`Das folgende Storybook zeigt den Button in einer Live Demo. Des Weiteren kann in dieser Testumgebung der Button mit verschiedenen Props und Variante getestet werden.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="React Dokumentation" actionIcon="launch" aspectRatio="2:1" href="https://storybook-cranachdesign.netlify.app/?path=/story/atoms-button--primary" mdxType="ResourceCard">
  </ResourceCard>
      </Column>
    </Row>
    <h3>{`Code`}</h3>
    <p>{`Button mit Standardwerten`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javaScript",
        "metastring": "path=CodeSandbox src=https://gatsby-theme-carbon.now.sh",
        "path": "CodeSandbox",
        "src": "https://gatsby-theme-carbon.now.sh"
      }}>{`
<Button />


`}</code></pre>
    <p>{`Beispiel: Button mit der Übergabe aller möglichen props`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javaScript",
        "metastring": "path=CodeSandbox src=https://gatsby-theme-carbon.now.sh",
        "path": "CodeSandbox",
        "src": "https://gatsby-theme-carbon.now.sh"
      }}>{`
<Button
  primary={false}
  label={'zur Webseite'}
  size={'large'}
  href={'https://lucascranach.org'}
  backgroundColor={'grey'}
/>

`}</code></pre>
    <h4>{`Props`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Optionen`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`type your label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Beschriftung des Buttons`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`primary`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`true`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode>{`, `}<inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Angabe über die Button-Variante`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`medium`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`small`}</inlineCode>{`, `}<inlineCode parentName="td">{`medium`}</inlineCode>{`, `}<inlineCode parentName="td">{`large`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Festlegung der Größe, Standard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`href`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://lucascranach.org"
            }}>{`https://lucascranach.org`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Die vollständige URL eines Links`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`backgroundColor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`null`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Farbe des Button-Containers`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Inhalt`}</h2>
    <h4>{`Label`}</h4>
    <p>{`Button-Beschriftungen sollten die Aktion des Button deutlich anzeigen. Um genügend Kontext bereitzustellen, verwenden die Inhaltsformel {Verb} + {Substantiv} für Schaltflächen, außer bei allgemeinen Aktionen wie “Fertig”, “Schließen”, “Abbrechen”, “Hinzufügen” oder “Löschen”.`}</p>
    <h2>{`Referenzen`}</h2>
    <ul>
      <li parentName="ul">{`Mehmet Goktürk,
`}<a parentName="li" {...{
          "href": "https://www.interaction-design.org/literature/book/the-glossary-of-human-computer-interaction/fitts-s-law"
        }}><em parentName="a">{`The Glossary of Human Computer Interaction, Chapter 37`}</em></a>{`
(The Interaction Design Foundation)`}</li>
      <li parentName="ul">{`Jakob Nielsen,
`}<a parentName="li" {...{
          "href": "https://www.nngroup.com/articles/ok-cancel-or-cancel-ok/"
        }}><em parentName="a">{`OK-Cancel or Cancel-OK? The Trouble With Buttons`}</em></a>{`
(Nielsen Norman Group, 2008)`}</li>
      <li parentName="ul">{`Artem Syzonenko
`}<a parentName="li" {...{
          "href": "https://uxdesign.cc/buttons-placement-and-order-bb1c4abadfcb"
        }}><em parentName="a">{`Buttons on the web: placement and order`}</em></a>{`
(UX Collective, 2019)`}</li>
    </ul>
    <h2>{`Feedback`}</h2>
    <p>{`Helfe uns um diese Komponente/Pattern zu verbessern, indem sie Feedback geben, fragen stelle oder andere Kommentare auf `}<a parentName="p" {...{
        "href": "https://github.com/cranach-design-system/cranach-design/issues/new?assignees=&labels=&template=website-feedback.md&title=Website+feedback"
      }}>{`Github`}</a>{` hinterlassen.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      